import {envConfigAtom} from '@web-catalog/env';
import {useHydrateAtoms} from 'jotai/react/utils';
import {memo, PropsWithChildren} from 'react';

import {OmicronContent} from '@web-catalog/api';

import {EnvConfig} from '@web-catalog/types/env';

import {categoriesAtom, CategoriesAtom} from '@web-catalog/store/categories';

import {omicronConfigAtom} from './omicronConfig';

type Props = {
  envConfig: EnvConfig;
  categories: CategoriesAtom;
  omicronConfig: OmicronContent;
};

export const HydrateAtoms = memo<PropsWithChildren<Props>>(
  ({envConfig, categories, omicronConfig, children}) => {
    useHydrateAtoms([
      [envConfigAtom, envConfig],
      [categoriesAtom, categories],
      [omicronConfigAtom, omicronConfig],
    ]);

    return <>{children}</>;
  },
);

HydrateAtoms.displayName = 'HydrateAtoms';
